window.slate = window.slate || {};
window.theme = window.theme || {};
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  initProductDetails: function () {
    const moreInfoContainer = document.querySelector('.more-info-container');
    if (!moreInfoContainer) return;

    const dialogBtns = document.querySelectorAll('.more-info-container button[data-dialog-target]');
    const dialogs = document.querySelectorAll('.more-info-dialog');

    // Open dialog on button click
    dialogBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const dialogId = btn.getAttribute('data-dialog-target');
        const dialog = document.getElementById(dialogId);
        if (dialog) {
          dialog.showModal();
        }
      });
    });

    // Close dialog handlers
    dialogs.forEach((dialog) => {
      // Close button
      const closeBtn = dialog.querySelector('.close-dialog');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          dialog.close();
        });
      }

      // Click on backdrop to close
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
          dialog.close();
        }
      });
    });
  },

  updatePdpInfoAndImages: async function() {
  try {
    const currentUrl = window.location.pathname + window.location.search;
    const response = await fetch(currentUrl);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.text();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = data;

    //------- KLAVIYO FORM

    let urlObj = new URL(window.location.href);
    let variantValue = urlObj.searchParams.get('variant');

    // Find the corresponding option in the select element
    let matchingOption;

    let hiddenSelect = document.getElementById('HiddenSelect');
    if(hiddenSelect) {
      matchingOption = hiddenSelect.querySelector('option[value="' + variantValue + '"]');
    }

    let disableKlaviyoBackInStock = true;
    if (matchingOption) {
      disableKlaviyoBackInStock = matchingOption.getAttribute('data-bis');
    }

    let klaviyoContainer = document.querySelector('.klaviyo-stock-notification-form-container');
    let tempklaviyoContainer = tempDiv.querySelector('.klaviyo-stock-notification-form-container');

    if (klaviyoContainer && tempklaviyoContainer && (disableKlaviyoBackInStock == "false" || disableKlaviyoBackInStock == "")) {
      klaviyoContainer.innerHTML = tempklaviyoContainer.innerHTML;
    }

    let formElement = document.getElementById('custom_klaviyo_form');
    let notifyButton = document.getElementById('notifyButton');
    let successMessage = document.querySelector('.success');
    let errorMessage = document.querySelector('.error');

    if (formElement && notifyButton) {
      formElement.addEventListener('submit', function(event) {
          event.preventDefault();
          notifyButton.click();
        });
    }

    if(notifyButton) {
      notifyButton.addEventListener('click', async () => {
        try {
          let result = await subscribeProductStockToKlaviyo(formElement);
          // console.log(result);
          if (!result.ok) {
            result = await result.json();
            throw new Error(result.errors[0].detail);
          }
          successMessage.classList.add('true');
          errorMessage.classList.remove('true');
          console.log(`You're now subscribed!`);
        } catch (e) {
          successMessage.classList.remove('true');
          errorMessage.classList.add('true');
          errorMessage.textContent = `Failed to subscribe: ${e.message}`;
          console.log(`Failed to subscribe. Reason: "${e.message}"`);
        }
    });
  }


    //------- PRODUCT INFO ACCORDIONS

    const productMainAccordionInfo = document.querySelector('.product__main-accordion');
    const tempProductMainAccordionInfo = tempDiv.querySelector('.product__main-accordion');

    if (productMainAccordionInfo && tempProductMainAccordionInfo) {

      // Remove active accordion in new variant page
      const tempActiveItem = tempProductMainAccordionInfo.querySelector('.accordion__item--active')
      if (tempActiveItem) {
        tempActiveItem.classList.remove('accordion__item--active');
      }

      // Get current active accordion index
      const activeItem = productMainAccordionInfo.querySelector('.accordion__item--active');

      if(activeItem) {
        const activeIndex = Array.from(productMainAccordionInfo.children).indexOf(activeItem);
        if (activeIndex !== -1 && productMainAccordionInfo.children[activeIndex]) {
          let tempActiveItemIndexed = tempProductMainAccordionInfo.children[activeIndex];
          if (tempActiveItemIndexed) {
            tempActiveItemIndexed.classList.add('accordion__item--active');
          }
        }
      }

      productMainAccordionInfo.innerHTML = tempProductMainAccordionInfo.innerHTML;

      this.initProductDetails();
    }

    // Update mobile description and details from new variant data
    const mobileDescription = document.querySelector('.description_mobile');
    const tempMobileDescription = tempDiv.querySelector('.description_mobile');
    if (mobileDescription && tempMobileDescription) {
      mobileDescription.innerHTML = tempMobileDescription.innerHTML;
    }

    const mobileDetails = document.querySelector('.details_mobile');
    const tempMobileDetails = tempDiv.querySelector('.details_mobile');
    if (mobileDetails && tempMobileDetails) {
      mobileDetails.innerHTML = tempMobileDetails.innerHTML;
    }

    // Update desktop details dialog from new variant data
    const desktopDetails = document.querySelector('.details_desktop');
    const tempDesktopDetails = tempDiv.querySelector('.details_desktop');
    if (desktopDetails && tempDesktopDetails) {
      desktopDetails.innerHTML = tempDesktopDetails.innerHTML;
    }

    //------- PRODUCT IMAGES

    const productGalleryStyle = document.querySelector('product-gallery-style');
    const thumbnailSliderStyle = document.querySelector('thumbnail-slider-style');
    const tempProductGalleryStyle = tempDiv.querySelector('product-gallery-style').innerHTML;
    const tempThumbnailSliderStyle = tempDiv.querySelector('thumbnail-slider-style').innerHTML;

    if (productGalleryStyle && thumbnailSliderStyle && tempProductGalleryStyle && tempThumbnailSliderStyle) {
      productGalleryStyle.innerHTML = tempProductGalleryStyle;
      thumbnailSliderStyle.innerHTML = tempThumbnailSliderStyle;

      createNewPdpSlider();

    } else {
      throw new Error('Error finding elements or updating innerHTML');
    }

    //----------- SHOP THE LOOK
    let shopTheLookContainer = document.querySelector('.shop-the-look-container');
    let tempShopTheLookContainer = tempDiv.querySelector('.shop-the-look-container');

    if (shopTheLookContainer && tempShopTheLookContainer) {
      shopTheLookContainer.innerHTML = tempShopTheLookContainer.innerHTML;
    } else if(shopTheLookContainer && !tempShopTheLookContainer) {
      shopTheLookContainer.remove();
    } else if(!shopTheLookContainer && tempShopTheLookContainer) {
      document.getElementById('detailsAccordion').append(tempShopTheLookContainer);
    }

    // -------------- VARIANT SUBTITLE

    let variantSubtitleContainer = document.querySelector('.product__text-block');
    let tempVariantSubtitleContainer = tempDiv.querySelector('.product__text-block');

    if (variantSubtitleContainer && tempVariantSubtitleContainer) {
      variantSubtitleContainer.innerHTML = tempVariantSubtitleContainer.innerHTML;
    } else if(variantSubtitleContainer && !tempVariantSubtitleContainer) {
      variantSubtitleContainer.remove();
    } else if(!variantSubtitleContainer && tempVariantSubtitleContainer) {
      document.querySelector('.sticky-product-name-limit').prepend(tempVariantSubtitleContainer);
    }

    // -------------- PRODUCT STORY VIDEO

    let productStoryVideoContainer = document.querySelector('.product_story .banner_video');
    let tempProductStoryVideoContainer = tempDiv.querySelector('.product_story .banner_video');

    if (productStoryVideoContainer && tempProductStoryVideoContainer) {
      productStoryVideoContainer.innerHTML = tempProductStoryVideoContainer.innerHTML;
    } else if(productStoryVideoContainer && !tempProductStoryVideoContainer) {
      productStoryVideoContainer.remove();
    } else if(!productStoryVideoContainer && tempProductStoryVideoContainer) {
      document.querySelector('.product_story .slider-mobile').insertAdjacentHTML('afterend', tempProductStoryVideoContainer);
    }

    let productNaturalStoryVideoContainer = document.querySelector('.natural_story .banner_video');
    let tempProductNaturalStoryVideoContainer = tempDiv.querySelector('.natural_story .banner_video');

    if (productNaturalStoryVideoContainer && tempProductNaturalStoryVideoContainer) {
      productNaturalStoryVideoContainer.innerHTML = tempProductNaturalStoryVideoContainer.innerHTML;
    } else if(productNaturalStoryVideoContainer && !tempProductNaturalStoryVideoContainer) {
      productNaturalStoryVideoContainer.remove();
    } else if(!productNaturalStoryVideoContainer && tempProductNaturalStoryVideoContainer) {
      document.querySelector('.natural_story .slider-mobile').insertAdjacentHTML('afterend', tempProductNaturalStoryVideoContainer);
    }

  } catch (error) {
    console.error('Error fetching or updating content:', error);
  }

  handleStickyElements();

},


};

// PB+J sticky add to bag bar in mobile PDP

window.addEventListener('scroll', handleStickyElements);
    window.addEventListener('resize', handleStickyElements);
    window.addEventListener('load', handleStickyElements);
    function initPdpSliderWhenReady() {
      var gallery = document.querySelector('product-gallery-style');
      if (!gallery || gallery.classList.contains('swiper-initialized')) return;
      if (typeof Swiper === 'undefined') return; // swiper-bundle.min.js hasn't run yet
      createNewPdpSlider();
    }

    // theme.js is deferred, so it executes while readyState is already 'interactive'
    // but BEFORE swiper-bundle.min.js (deferred, end of <body>) has run. Wait for
    // DOMContentLoaded, by which point every deferred script has executed.
    if (document.readyState === 'complete') {
      initPdpSliderWhenReady();
    } else {
      document.addEventListener('DOMContentLoaded', initPdpSliderWhenReady);
      window.addEventListener('load', initPdpSliderWhenReady, { once: true }); // safety net
    }
    

function handleStickyElements() {

let stickyHolderProductInfo = document.querySelector('.product__title-price.sticky-element:not(.sticky-duplicate)');
let stickyHolderAddToBag = document.querySelector('.add-to-bag-wrapper.sticky-element:not(.sticky-duplicate)');
let stickyBar = document.querySelector('section.sticky-bar');
let klaviyoForm = document.getElementById('custom_klaviyo_form');

let swatchWrap = document.querySelector('.swatch_wrap');

let scrollTimeout;


if (!document.querySelector('.template-product') || !stickyHolderProductInfo || !stickyHolderAddToBag || window.innerWidth > 768) return;

if (scrollTimeout) {
  clearTimeout(scrollTimeout);
}

scrollTimeout = setTimeout(function () {


  let scrollY = window.scrollY;
  let innerHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

  let productNameLimit = document.querySelector('.accordion__item-title');
  let addToCartOriginalButtonWrapper = document.querySelector('.add-to-bag-wrapper:not(.sticky-duplicate) button');
  let klaviyoButton = document.querySelector('.klaviyo-stock-notification-form-container button');
  let addToCartLimit = document.querySelector('.sticky-atc-limit');

  let urlObj = new URL(window.location.href);
  let variantValue = urlObj.searchParams.get('variant');
  let selectedVariant = "";
  let hiddenSelect = document.getElementById('HiddenSelect');

  // A PDP loaded without ?variant= has no matching <option>, so querySelector
  // returns null and this used to throw, aborting the whole sticky-bar handler
  // on every scroll/resize. Bail out quietly instead - behaviour is unchanged
  // (nothing below this point had run), just without the console error.
  let matchedOption = (hiddenSelect && variantValue)
    ? hiddenSelect.querySelector('option[value="' + variantValue + '"]')
    : null;

  if (!matchedOption) return;

  selectedVariant = matchedOption.getAttribute('data-variant-title') || "";

  let $matchedOption = $(matchedOption);
  let inventoryQuantity = $matchedOption.data('inventory');
  let isKlaviyoDisabled = $matchedOption.data('bis'); // Back in stock disabled variable



  // Handle stickyHolderAddToBag
  if (scrollY <= 800 &&
    ((addToCartOriginalButtonWrapper != null && !isElementInViewport(addToCartOriginalButtonWrapper)) ||
    (klaviyoButton != null && !isElementInViewport(klaviyoButton)))
  ) {

    let oldDuplicate = stickyBar.querySelector('.sticky-duplicate.add-to-bag');
    if (oldDuplicate) {
      stickyBar.removeChild(oldDuplicate);
      // Remove the variant name div if it exists
      let oldVariantNameDiv = stickyBar.querySelector('.variant-name');
      if (oldVariantNameDiv) {
        stickyBar.removeChild(oldVariantNameDiv);
      }
    }

    let duplicate = stickyBar.querySelector('.sticky-duplicate.add-to-bag');
    if (!duplicate) {
      duplicate = stickyHolderAddToBag.cloneNode(true);
      duplicate.classList.add('sticky-duplicate', 'add-to-bag');
      const childButton = duplicate.querySelector('button');
      const childButtonSpan = childButton.querySelector('span');
      if (childButton) {
          childButton.setAttribute('form', 'productForm');
      }

      // Create and insert the variant name div before the duplicate
      let variantNameDiv = document.createElement('div');
      variantNameDiv.classList.add('variant-name');
      variantNameDiv.setAttribute('onclick', "document.querySelector('.sticky-atc-limit').scrollIntoView({ block: 'end', behavior: 'smooth' });");
      variantNameDiv.textContent = selectedVariant;

      stickyBar.insertBefore(duplicate, stickyBar.firstChild);
      if (!isElementInViewport(swatchWrap)) {
        stickyBar.insertBefore(variantNameDiv, stickyBar.firstChild);
      }
      addKlaviyoBIStoSTickyBar(childButtonSpan, inventoryQuantity, isKlaviyoDisabled);
    }
  } else {
    let duplicate = stickyBar.querySelector('.sticky-duplicate.add-to-bag');
    if (duplicate) {
      stickyBar.removeChild(duplicate);
      // Remove the variant name div if it exists
      let variantNameDiv = stickyBar.querySelector('.variant-name');
      if (variantNameDiv) {
        stickyBar.removeChild(variantNameDiv);
      }
    }
  }

  function addKlaviyoBIStoSTickyBar(element, stock, isDisabled) {
    //console.log(element, element.parentElement)
    let klaviyoCopy = document.querySelector('#notifyButton').innerHTML;
    if(stock <= 0 && !isDisabled){
      element.innerHTML = klaviyoCopy;
      element.addEventListener('click', () => {
        document.querySelector('.klaviyo-stock-notification-form-container').scrollIntoView({ block: 'end', behavior: 'smooth' });
      })
    }
  }
  /*
  // Handle stickyHolderProductInfo
  if (!isElementInViewport(productNameLimit) && scrollY <= 400) {

    let oldInfoDuplicate = stickyBar.querySelector('.sticky-duplicate.product-info');
    if (oldInfoDuplicate) {
      stickyBar.removeChild(oldInfoDuplicate);
    }

    let duplicate = stickyBar.querySelector('.sticky-duplicate.product-info');
    if (!duplicate) {
      duplicate = stickyHolderProductInfo.cloneNode(true);
      duplicate.classList.add('sticky-duplicate', 'product-info');
      stickyBar.insertBefore(duplicate, stickyBar.firstChild);
    }
  } else {
    let duplicate = stickyBar.querySelector('.sticky-duplicate.product-info');
    if (duplicate) {
      stickyBar.removeChild(duplicate);
    }
  }
  */

}, 1);
}

function isElementInViewport(el) {
if(el) {
  const rect = el.getBoundingClientRect();
  const iHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  const iWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (iHeight || document.documentElement.clientHeight) &&
    rect.right <= (iWidth || document.documentElement.clientWidth)
  );
}
}

function createNewPdpSlider() {
  const newSliderMain = document.querySelector('product-gallery-style');
  const newSliderThumbs = document.querySelector('thumbnail-slider-style');

  if (newSliderMain && newSliderThumbs) {
    try { if (window.__pdpGallery) window.__pdpGallery.destroy(true, true); } catch (e) {}
    try { if (window.__pdpThumbs) window.__pdpThumbs.destroy(true, true); } catch (e) {}
    window.__pdpGallery = null;
    window.__pdpThumbs = null;

    const activateInfiniteLoopThumbs = (document.querySelectorAll('thumbnail-slider-style .swiper-slide').length > 4);

    const ThumbnailSlider = new Swiper(newSliderThumbs, {
      loop: activateInfiniteLoopThumbs,
      spaceBetween: 17,
      slidesPerView: 4,
      speed: 800,
      navigation: {
        nextEl: 'thumbnail-slider-style .swiper-button-next',
        prevEl: 'thumbnail-slider-style .swiper-button-prev'
      }
    });

    const sliderPagination = newSliderMain.querySelector('.swiper-pagination');

    const ProductGallery = new Swiper(newSliderMain, {
      zoom: {
        containerClass: 'swiper-zoom-container',
      },
      loop: true,
      autoHeight: false,
      simulateTouch: true,
      spaceBetween: 0,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: 'product-gallery-style .swiper-button-next',
        prevEl: 'product-gallery-style .swiper-button-prev'
      },
      thumbs: {
        swiper: ThumbnailSlider
      },
      pagination: {
        el: sliderPagination,
        clickable: true
      }
    });

    ProductGallery.on('touchEnd', function(thisSlider) {
      thisSlider.zoom.out();
      thisSlider.allowTouchMove = true
    });

    ProductGallery.on('touchMove', function(thisSlider) {
      if(thisSlider.zoom.scale > 1) {
        thisSlider.allowTouchMove = false
      }
    });

    window.__pdpThumbs = ThumbnailSlider;
    window.__pdpGallery = ProductGallery;


  }
}

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */
slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }
  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;

        }
      });
      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);
      return currentOptions;
    },
    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = false;
      variants.forEach(function(variant) {
        var satisfied = true;
        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });
        if (satisfied) {
          found = variant;
        }
      });
      return found || null;
    },
    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      if ($('.selected-values').length > 0) {
          if (variant) {
          $(".selected-values").text(variant.title);
          $( ".Size_swatch .swatch_option" ).html(variant.option2);
          }
        }
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
    if (typeof sizeSelected !== 'undefined' && sizeSelected){
      var selector = this.originalSelectorId;
      if (variant) {
        var form = $(selector).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      }
    }
      // END SWATCHES



      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },
    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    },
    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });
  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price], [data-product-price-atc]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      // PBJ remove native update product image for new PDP
      // this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
     updateAddToCartState: function(evt) {
       var variant = evt.variant;
       if (variant) {
        // $(selectors.priceWrapper, this.$container).removeClass('hide');
       } else {
         $(selectors.addToCart, this.$container).prop('disabled', true);
         $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
         $(selectors.priceWrapper, this.$container).addClass('hide');
         return;
       }

       if (typeof sizeSelected !== 'undefined' && sizeSelected === false) return
       if (variant.available) {
         $(selectors.addToCart, this.$container).prop('disabled', false);
         $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
         // $(selectors.addToCart, this.$container).css('display', 'block');
       } else {

         $(selectors.addToCart, this.$container).prop('disabled', true);
         $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
         // $(selectors.addToCart, this.$container).css('display', 'none');
       }
     },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize + '_crop_center');
      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();





/**
 * Product Details Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product Details pg.
 * template.
 *
 *
 */
//new product details code
/*
 if ($('[data-product-select]').length > 0) {
  //Product select validation
  $('.size-option').filter(function() {
    return $(this).find('option')
  }).prepend('<option value="">Pick a ' + productOptions + '</option>').val('').trigger('change');
}
*/
/*
  The #zoomWindow modal handlers were removed on 20 Aug 2026. The modal markup is
  still in the page but nothing opens it (zero elements target it), and the
  handlers read .slick-current .image-zoom / .onload_img .image-zoom / .mobile-zoom,
  none of which exist since the slick gallery became a swiper component.
*/
//change variants
$(function() {
  $(document).on('change', '.swatch .color_radio', function() {
    //console.log('start')
    const colorItem = $(this).parent().find('label span');
    if(colorItem){
      const colorTitle = $(colorItem).text();
      $('[data-color-label]').first().text(colorTitle);
    }

    // Price is updated by Slate's own Variants class: changing the
    // .single-option-selector below fires 'variantPriceChange', and
    // updateProductPrices() writes [data-product-price-atc] with
    // slate.Currency.formatMoney() and handles compare-at price.
    // .spec_details, ._details and .product_color are not rendered by this theme;
    // Wash & Care is server-rendered (snippets/variant-copy-blocks.liquid).
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    // The gallery is a swiper component now; slate.utils.updatePdpInfoAndImages()
    // swaps <product-gallery-style> / <thumbnail-slider-style> on variant change.
    setTimeout(initVimeoWithListener, 1000);
  });
});

/*
  Wash & Care copy is rendered server-side, one block per colour, by
  snippets/variant-copy-blocks.liquid. Every colour is already in the HTML with
  all but the selected one [hidden], so the panel is correct on first paint with
  no JavaScript. This only re-points it when the shopper changes colour.
*/
function syncVariantCopy(colorValue) {
  var blocks = document.querySelectorAll('.variant-copy');
  if (!blocks.length || colorValue == null) return;
  for (var i = 0; i < blocks.length; i++) {
    blocks[i].hidden = blocks[i].getAttribute('data-copy-color') !== colorValue;
  }
}
/*
  The story is rendered once per distinct story metaobject by
  snippets/variant-story-blocks.liquid, each block tagged with the colours that
  use it. Reveal the block covering the chosen colour. Selection is by
  metaobject, so this no longer depends on a colour being named "Undyed".
*/
function syncVariantStory(colorValue) {
  var blocks = document.querySelectorAll('.story-variant');
  if (!blocks.length || colorValue == null) return;
  var probe = '||' + colorValue + '||';
  for (var i = 0; i < blocks.length; i++) {
    var colors = blocks[i].getAttribute('data-story-colors') || '';
    blocks[i].hidden = colors.indexOf(probe) === -1;
  }
}
$(document).on('change', '.swatch .color_radio', function () {
  syncVariantCopy(this.value);
  syncVariantStory(this.value);
});

//load thumbnails and all content on page load
/*
  load_swatch_img() was removed on 19 Aug 2026. It read the swatch inputs'
  data-* attributes and injected them into .care_details, .spec_details,
  ._details and .product_color. Its only caller was the slick gallery's 'init'
  event, and that gallery was replaced by a swiper component — so it had not run
  for some time, and every container it targeted is either server-rendered now
  or absent from the markup entirely.
*/
/*
  swapThumbs() was removed on 20 Aug 2026: it bound clicks on .thumb-link and
  rewrote .featured_img, neither of which exists in the markup any more.
*/
//select

$(".Color_swatch .dropdown-menu li label").click(function() {
  $('.dropdown-item.selected').removeClass('selected');
  $(this).parents('.dropdown-item').addClass('selected');
});

$(".dropdown-menu li label").click(function() {
  var selText = $(this).text();
  //console.log(selText);
  $(this).parents('.btn-group').find('.btn').html('<span class="swatch_option">' + selText + '</span> <span class="spacer"></span>');
});
// Scroll to a certain element
// Add smooth scrolling to all links
$(".learn_more").on('click', function(event) {
  // Make sure this.hash has a value before overriding default behavior
  if (this.hash !== "") {
    // Prevent default anchor click behavior
    event.preventDefault();
    // Store hash
    var hash = this.hash;
    // Using jQuery's animate() method to add smooth page scroll
    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    $('html, body').animate({
      scrollTop: $(hash).offset().top + (-140)
    }, 800, function() {
      // Add hash (#) to URL when done scrolling (default click behavior)
      // window.location.hash = hash;
    });
  } // End if
});
//vimeo
function initVimeoWithListener() {

  $('.vimeo-modal').click(function(event) {
  event.preventDefault();
  //console.log(termValue);getSlick
  //$('#video_modal').modal();
  //grab the data id
  var video_id = $(this).data('id');
  // console.log(video_id);
  var htmlData = '<button style="position: absolute;top: 30px;z-index: 99;left: 20px;" type="button" class="close video_close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
  htmlData += '<iframe class="vimeo_player" id="player" src="https://player.vimeo.com/video/' + video_id + '?api=1&player_id=player' + video_id + '&amp;autoplay=1&amp;loop=1&amp;autopause=0" width="630" height="354" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
  $('.video_wrapper').append(htmlData);
  setTimeout(function() {

    //reload the script
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://player.vimeo.com/api/player.js';
    head.appendChild(script);
  }, 400);
  setTimeout(function() {
    player.play().then(function() {
      // the video was played
    }).catch(function(error) {
      switch (error.name) {
        case 'PasswordError':
          // the video is password-protected and the viewer needs to enter the
          // password first
          break;
        case 'PrivacyError':
          // the video is private
          break;
        default:
          // some other error occurred
          break;
      }
    });
  }, 450);
  $('.video_close').on('click', function() {
    $(".vimeo_player").remove();
    $(".video_close").remove();
  });
});
}

initVimeoWithListener();
window.initVimeoWithListener = initVimeoWithListener;

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
  // Target tables to make them scrollable
  var tableSelectors = '.rte table';
  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });
  // Target iframes to make them responsive
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';
  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });
  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  //add class on hover @homepage
  $('._on_hover').hover(function() {
    $(this).addClass('active');
  });
  //add to cart
  jQuery(function() {
    CartJS.init(shoppingBag, {
      dataAPI: true,
      requestBodyClass: 'cart-loading',
      "moneyFormat": "",
      "moneyWithCurrencyFormat": "",
      // Define an error callback to display an error message.
    });
  });
  //homepage
  //mobile menu
  var isLateralNavAnimating = false;
  /*
  //open/close lateral navigation
  $('.cd-nav-trigger').on('click', function(event) {
    event.preventDefault();
    //stop if nav animation is running
    if (!isLateralNavAnimating) {
      if ($(this).parents('.csstransitions').length > 0) isLateralNavAnimating = true;
      $('.cd-side-nav').toggleClass('nav-is-visible');
      $('body').toggleClass('overflow_hidden');
      $('.cd-nav-trigger').toggleClass('nav-is-visible');
      $('.cd-side-nav').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
        //animation is over
        isLateralNavAnimating = false;
      });
    }
  });
  */



  // $('.cart_view').on('click', function(event) {
  //   event.preventDefault();
  //   //stop if nav animation is running
  //   if (!isLateralNavAnimating) {
  //     if ($(this).parents('.csstransitions').length > 0) isLateralNavAnimating = true;
  //     if ( window.innerWidth < 668 ) {
  //       if ( $('.shopping-cart').css('display') === 'block' ) $('body').trigger('hideCartMobile')
  //       else $('body').trigger('showCartMobile')
  //     } else {
  //     	$('body').toggleClass('load-product');
  //       $('.shopping-cart').show();
  //     }

  //     $('body').toggleClass('overflow_hidden');
  //     $('.overlay-form').toggleClass('darken');
  //     $('.cart_view').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
  //       //animation is over
  //       isLateralNavAnimating = false;
  //     });

  //   }
  // });
  $('.overlay-form').on('click', function() {
    if ( window.innerWidth < 668 ) {
      $('body').trigger('hideCartMobile')
    } else {
      $('body').removeClass('load-product');
      $('.shopping-cart').hide();
    }
    $(this).removeClass('darken');
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    if ( window.innerWidth < 668 ) {
      $('body').trigger('showCartMobile')
    } else {
    	$('body').addClass("load-product");
    }
    $('.overlay-form').addClass('darken');
    setTimeout(function() {
      if ( window.innerWidth < 668 ) {
        $('body').trigger('hideCartMobile')
      } else {
        $('body').removeClass("load-product");
      }
      $('.overlay-form').removeClass('darken');
    }, 6000);
  });
  //cookies banner
  /*
  $("#cookies").addClass("display");
     $("#close-cookies").click(function(){
      event.preventDefault();
      $("#cookies").addClass("close-cookies");
    });
    */
  //close all modals before opening new one
  $('.modal').on('show.bs.modal', function() {
    $('.modal').not($(this)).each(function() {
      $(this).modal('hide');
    });
  });
  //click on item and show submenu
  $('.has-children > a').on('click', function(event) {
    var selectedItem = $(this);
    event.preventDefault();
    if (selectedItem.parent('li').hasClass('selected')) {
      selectedItem.parent('li').removeClass('selected');
    } else {
      $('.cd-side-nav').find('.has-children.selected').removeClass('selected');
      selectedItem.parent('li').addClass('selected');
    }
  });
  //menu
  $("#menu").mmenu({
    navbar: {
      title: ""
    },
    "navbars": [
      {
        "position": "bottom",
        "content": [
                      "<div class='shipping_notification d-none'><em><a href='/pages/shipping-options'>Free shipping on orders over $75*</a></em></div>"
                    ]
                 }
              ],
    "extensions": [
                    "pagedim-black",
                    "position-front"
                 ]
  });
  //clock function
  function showTime() {
    var date = new Date();
    var pstOffset = -7; // PST offset is UTC-8
    var utc = date.getTime() + (date.getTimezoneOffset() * 60000); // Get UTC time
    var pst = new Date(utc + (pstOffset * 3600000)); // Adjust to PST

    var h = pst.getHours(); // 0 - 23
    var m = pst.getMinutes(); // 0 - 59
    var s = pst.getSeconds(); // 0 - 59
    var session = "AM";
    if (h == 0) {
      h = 12;
    }
    if (h > 12) {
      h = h - 12;
      session = "PM";
    }
    h = (h < 10) ? "0" + h : h;
    m = (m < 10) ? "0" + m : m;
    s = (s < 10) ? "0" + s : s;
    var time = h + ":" + m + ":" + s + " " + session;
    document.getElementById("MyClockDisplay").innerText = time;
    document.getElementById("MyClockDisplay").textContent = time;
    setTimeout(showTime, 1000);
  }
  var clock = document.getElementById("MyClockDisplay");
  if (clock) {
    showTime();
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    today = mm + '/' + dd + '/' + yyyy;

    document.getElementById('myDate').innerHTML = today;
  }

  // Offset alignment for announcement bar
  const announcementBar = document.querySelector('#shopify-section-announcement-bar .announcement-bar');
  const announcementBarOffsetTop = announcementBar ? parseFloat(announcementBar.dataset.offsetTop) : 0;

  //sticky header
  /**
 * Handles sticky header behavior on scroll and load.
 * Adds or removes 'fixed-header' and 'fixed-ab' classes based on
 * scroll position, unless the search modal is currently open.
 */
function handleStickyHeader() {
  const mainHeader = document.querySelector('.main_header');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');
  const searchModal = document.querySelector('.search-modal');

  const isSearchOpen = searchModal && searchModal.classList.contains('is-open');

  if (!isSearchOpen) {
    if (window.scrollY >= announcementBarOffsetTop) {
      mainHeader.classList.add('fixed-header');
      announcementBar.classList.add('fixed-ab');
    } else {
      mainHeader.classList.remove('fixed-header');
      announcementBar.classList.remove('fixed-ab');
    }
  }
}

/**
 * Forces the sticky header classes when the mobile search icon is clicked.
 * Ensures the header remains fixed while the search modal is open.
 */
function handleMobileSearchClick(event) {
  if (event.target.closest('.search__mobile')) {
    document.querySelector('.main_header').classList.add('fixed-header');
    document.querySelector('#shopify-section-announcement-bar').classList.add('fixed-ab');
  }
}

/**
 * Removes the sticky header classes when the modal close button is clicked.
 * Restores normal header scroll behavior after the search modal is dismissed.
 */
function handleModalCloseClick(event) {
  if (event.target.closest('button.close[data-dismiss="modal"]')) {
    document.querySelector('.main_header').classList.remove('fixed-header');
    document.querySelector('#shopify-section-announcement-bar').classList.remove('fixed-ab');
  }
}

// Run sticky header logic on initial page load and on every scroll event
window.addEventListener('load', handleStickyHeader);
window.addEventListener('scroll', handleStickyHeader);

// Use event delegation on the document to handle dynamically rendered elements
document.addEventListener('click', handleMobileSearchClick);
document.addEventListener('click', handleModalCloseClick);

  // Focus search input when modal opens (native search modal)
  document.addEventListener('search-modal:open', function() {
    const searchInput = document.querySelector('.search-modal .js-search-input');
    if (searchInput) searchInput.focus();
  });
  //collections pg.
  /*
  var lazyLoadInstances = [];
  // The "lazyLazy" instance of lazyload is used (kinda improperly)
  // to check when the .horzContainer divs enter the viewport
  var lazyLazy = new LazyLoad({
    //elements_selector: ".horzContainer",
    // When the .horzContainer div enters the viewport...
    callback_set: function(el) {
      // ...instantiate a new LazyLoad on it
      var oneLL = new LazyLoad({
        container: el
      });
      $(".prod-collection-thumb").on('click mouseover', function(e) {
        e.preventDefault();
        //var src = $(this).attr('href');
        var mainCollection_img = $(this).data("image");
        var srcset_imgs = $(this).data("srcset");
        var prodLink = $(this).data("url");
        var prodTitle = $(this).data("title");
        $(this).closest('.product_item').find('.primary_collection_img').attr('src', mainCollection_img.replace('thumb', 'large'));
        $(this).closest('.product_item').find('.primary_collection_img').attr('srcset', srcset_imgs);
        $(this).closest('.product_item').find('.product_link').attr("href", prodLink);
        $(this).closest('.product_item').find('.product_title').html(prodTitle);
        $('.prod-collection-thumb').removeClass('active');
        $(this).addClass('active');
      });
      // Optionally push it in the lazyLoadInstances
      // array to keep track of the instances
      lazyLoadInstances.push(oneLL);
    }
  });
  */
  /*
  if ($('[data-product-select]').length > 0) {
    //Product select validation
    $('.size-option').filter(function() {
      return $(this).find('option')
    }).prepend('<option value="">Pick a ' + productOptions + '</option>').val('').trigger('change');
  }
  */
  //product qty click
  // This button will increment the value
  $('.qtyplus').click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($(e.target).closest('.qty-wrapper').find('.qty_number').val());
    var currentInput = $(this).closest('.qty-wrapper').find('.qty_number').val();

    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $(this).closest('.qty-wrapper').find('.qty_number').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $(this).closest('.qty-wrapper').find('.qty_number').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($(e.target).closest('.qty-wrapper').find('.qty_number').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $(this).closest('.qty-wrapper').find('.qty_number').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $(this).closest('.qty-wrapper').find('.qty_number').val.val(0);
    }
  });
});

/*if(window.innerWidth > 425){
  let imgDetails = document.querySelectorAll('.productDetails-sliderMobile');
}
*/

//Product details thumbnails slider
$('.product_slider').slick({
  slidesToShow:1,
  slidesToScroll:1,
  infinite: false,
  dots: false,
  arrows: true,
  asNavFor: '.slider-nav',
  responsive: [
    {
      breakpoint: 668,
      settings: {
        dots: true,
        arrows: false,
      }
        }
      ]
});


// validate size
$(document).on("click", ".itemscope-details form button.avail_stock", function(e){
  	var options = []
    $(".btn-group .swatch_option").each(function(){
      var self = $(this)
      options.push( self.text() )
    });

    if( options[0] != 'Color' && options[1] != 'Size' ){
      return true
    } else {
    	e.preventDefault();
        var html = '<div class="errorSize">You must select a size and a color</div>'
        if( !$('.swatch_wrap .errorSize')[0] ){
        	$('.swatch_wrap').append(html)
        }
      	setTimeout(function(){ $('.swatch_wrap .errorSize').remove() }, 3000);
    }

});



/*
$('.image-zoom').wrap('<span class="zoom_container" style="display:inline-block;"></span>').css('display', 'block').parent().zoom({
  url: $(this).find('.image-zoom').attr('data-zoom'),
  on: 'click',
  touch: false,
  magnify: 1,
});
*/

let disablePopUp = document.querySelector('div.outer-product_slider > button.btn.btn-primary.zoom-btn');

if(disablePopUp != null){
  if(window.innerWidth <= 425 ){
    disablePopUp.style.display = "none";
  }
}

$('#AnnouncementSlider').slick({
  accessibility: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 5000,
  touchThreshold: 20,
  slidesToShow: 1,
  vertical : true
})
function setChartSize( size = "in"){
  $("#sizeChart .modal-body .table-responsive table tr td").each(function( ) {
      let inch = $(this).data("in");
      let cm = $(this).data("cm");
      if(inch && size == "in"){
        $(this).html(inch);
      }
      if(cm && size == "cm"){
        $(this).text(cm);
      }
  })
}
function setUpChart( size = "in"){
  $("#sizeChart .modal-body .table-responsive table tr td").each(function( ) {
      const sizeArray = this.innerText.split("/");
      if(sizeArray.length == 2){
        $(this).data("in",sizeArray[0])
        $(this).data("cm",sizeArray[1])

      }
     setChartSize();
  })
}
if($("#sizeChart")){
   setUpChart();
  $(".size-toggle .toggle").click(function(e) {
      $(".size-toggle .toggle").removeClass("active");
      $(this).addClass("active")
      let size = $(this).data("size");
      setChartSize(size)
  })
  if(window.innerWidth < 1090){
    let ratio = window.innerWidth / 1130;

    $("#sizeChart .modal-content").css('transform', 'scale(' + ratio + ')');
    $(window).on('resize', function(){
      console.log('resizing')
        ratio = window.innerWidth / 1130;
        $("#sizeChart .modal-content").css('transform', 'scale(' + ratio + ')');
    });
  }

   // $("#sizeChart table").on("touchstart", function(e) {
   //          e.preventDefault();
   //       const target = e.target;
   //       console.log('toouvh')
   //       if(target.tagName == "TD"){
   //           console.log('toouvh')
   //          $(target).addClass('touch-active')
   //       }

   // })
  // $("#sizeChart table").on("touchend", function(e) {
  //           e.preventDefault();
  //         $("#sizeChart table td").removeClass('touch-active')
  //       });
  //  $("#sizeChart .zoom-btn").click(function(e) {
  //           e.preventDefault();
  //           let fontSize = parseInt($("#sizeChart .modal-content .modal-body .table td").first().css("font-size"));
  //           fontSize = fontSize + 1 + "px";
  //           $("#sizeChart .modal-content .modal-body .table td").css("fontSize", fontSize);

  // });

}
if($('.template-product').length && $(window).width() <= 768) {

    var isInViewport = (el) => {
      var elementTop = $(el).offset().top;
      var elementBottom = elementTop + $(el).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $(window).scroll(function() {

      // if(isInViewport('.product__submit__buttons')) {
      //   $('.btn--add-to-cart').removeClass('sticky-button')
      //   $('#add-cart-container').removeClass('sticky-button');
      // } else {
      //   $('.btn--add-to-cart').addClass('sticky-button')
      //   $('#add-cart-container').addClass('sticky-active')
      // }
    })
  }
